import nSs1 from "./ns-standar (1).png";
import nSs2 from "./ns-standar (2).png";
import nSs3 from "./ns-standar (3).png";
import nSs4 from "./ns-standar (4).png";

const nSs = [nSs1, nSs2, nSs3, nSs4];

export default nSs;
